import { useConfirmStore } from "../stores/Confirm";

export interface UseConfirmOptions {
  title?: string;
  text?: string;
}

export default function useConfirm(options?: UseConfirmOptions) {
  const { openConfirmDialog } = useConfirmStore();

  const confirm = (successAction: () => any) => {
    openConfirmDialog({
      function: successAction,
      text: options?.text,
      title: options?.title,
    });
  };

  return confirm;
}
